var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',{staticClass:"column-id"}),_vm._v(" "),_c('td',{staticClass:"column-name"},[_vm._v("\n    "+_vm._s(_vm.model.amount)+"\n  ")]),_vm._v(" "),_c('td',{staticClass:"column-date"},[_vm._v("\n    "+_vm._s(_vm.createdAt)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }